import isValid from 'date-fns/isValid';
import isWithinInterval from 'date-fns/isWithinInterval';

export const maintenanceCheckENV = () => {
  const data: {
    maintenanceActive: boolean;
    maintenanceBegin: string;
    maintenanceEnd: string;
  } = {
    maintenanceActive: false,
    maintenanceBegin: '',
    maintenanceEnd: '',
  };

  const mWindow = process.env.REACT_APP_MAINTENANCE_WINDOW || '';

  // Check whether or not a window has been set in an ENV variable
  const hasWindow = (envVariable: string) => {
    if (
      envVariable !== null &&
      envVariable !== undefined &&
      envVariable.trim() !== '' &&
      envVariable.trim() !== ','
    ) {
      return true;
    }

    return false;
  };

  if (hasWindow(mWindow) && mWindow !== '') {
    // ["2021-02-15T17:00:00.000Z", "2021-02-15T19:00:00.000Z"]
    const mWindowArray = mWindow.split(',');
    if (mWindowArray.length === 2) {
      // "2021-02-15T17:00:00.000Z"
      const mBegin = mWindowArray[0];
      // "2021-02-15T19:00:00.000Z"
      const mEnd = mWindowArray[1];

      if (
        mBegin.length &&
        isValid(new Date(mBegin)) &&
        mEnd.length &&
        isValid(new Date(mEnd))
      ) {
        data.maintenanceActive = isWithinInterval(new Date(), {
          start: new Date(mBegin),
          end: new Date(mEnd),
        });
        data.maintenanceBegin = mBegin;
        data.maintenanceEnd = mEnd;
      }
    }
  }

  return data;
};
